import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { useMemo } from "react";
import HowToBuyItem from "@/pages/homePageV2/homePageComponents/components/HowToBuy/HowToBuyItem";
import { twMerge } from "tailwind-merge";
var HowToBuySection = function HowToBuySection(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$showDescription = _ref.showDescription,
    showDescription = _ref$showDescription === void 0 ? true : _ref$showDescription,
    _ref$innerWrapperClas = _ref.innerWrapperClassName,
    innerWrapperClassName = _ref$innerWrapperClas === void 0 ? "" : _ref$innerWrapperClas;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong;
  var howToBuyItems = useMemo(function () {
    return [{
      key: "howToBuy1",
      src: "/assets/images/howToBuy/step1.svg",
      //src: "/assets/images/homepage/how_to_buy/step1.webp",// TODO: use this
      title: tShort("howToBuyUsp/usp_one_title", {
        ns: "web_home"
      }),
      description: tLong("howToBuyUsp/usp_one_description", {
        ns: "web_home"
      })
    }, {
      key: "howToBuy2",
      src: "/assets/images/howToBuy/step2.svg",
      //src: "/assets/images/homepage/how_to_buy/step2.webp",// TODO: use this
      title: tShort("howToBuyUsp/usp_two_title", {
        ns: "web_home"
      }),
      description: tLong("howToBuyUsp/usp_two_description", {
        ns: "web_home"
      })
    }, {
      key: "howToBuy3",
      src: "/assets/images/howToBuy/step3.svg",
      //src: "/assets/images/homepage/how_to_buy/step3.webp",// TODO: use this
      title: tShort("howToBuyUsp/usp_three_title", {
        ns: "web_home"
      }),
      description: tLong("howToBuyUsp/usp_three_description", {
        ns: "web_home"
      })
    }, {
      key: "howToBuy4",
      src: "/assets/images/howToBuy/step4.svg",
      //src: "/assets/images/homepage/how_to_buy/step4.webp",// TODO: use this
      title: tShort("howToBuyUsp/usp_four_title", {
        ns: "web_home"
      }),
      description: tLong("howToBuyUsp/usp_four_description", {
        ns: "web_home"
      })
    }];
  }, [tShort, tLong]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: twMerge("px-4 w-full lg:bg-blue-alice lg:px-0", className)
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("bg-blue-alice lg:bg-[transparent] flex flex-col gap-8 px-4 pt-4 pb-8 rounded-2xl lg:max-w-[1150px] mx-auto lg:pt-16 lg:pb-[72px] lg:gap-16 lg:px-0", innerWrapperClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start gap-1 items-center lg:justify-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/assets/images/howToBuy/question3d.webp",
    alt: "question-mark",
    loading: "lazy",
    width: "40px",
    height: "40px",
    className: "lg:hidden"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "text-primary text-start text-base font-bold lg:text-center lg:text-2xl lg:font-bold"
  }, tShort("howToBuyUsp/main_title", {
    ns: "web_home"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 lg:flex-row"
  }, howToBuyItems.map(function (item, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HowToBuyItem, {
      key: item.key + index,
      src: item.src,
      title: item.title,
      description: showDescription ? item.description : undefined,
      number: "0" + (index + 1)
    }));
  })))));
};
export default HowToBuySection;